import { createSelector } from 'reselect';

export const guestEventsRequestsContainer = ({ guestEventsRequests }) => guestEventsRequests;

export const guestEventRequestssSelector = createSelector(
  [guestEventsRequestsContainer],
  (guestEventsRequests) => ({ guestEventsRequests }),
);
